import { FC } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as customersActions from "../../../store/actions/customersActions";
import { Customer } from "../../auth/Auth";
import { Box, Button, Divider, Modal, ModalDialog, Typography } from "@mui/joy";
import { Delete, WarningRounded } from "@mui/icons-material";

interface CustomerModalProps {
    open: boolean;
    selectedCustomer: Customer | null;
    onHandleClose: () => void;
}

const DeleteCustomerModal: FC<CustomerModalProps> = ({ open, selectedCustomer, onHandleClose }) => {
    const dispatch = useDispatch();
    const { deleteCustomer } = bindActionCreators(customersActions, dispatch);

    const handleDeleteCustomer = (): void => {
        if (!selectedCustomer) return;

        deleteCustomer(selectedCustomer);
        onHandleClose();
    };

    return (
        <Modal open={open} onClose={onHandleClose}>
            <ModalDialog
                variant="outlined"
                role="alertdialog"
                aria-labelledby="alert-dialog-modal-title"
                aria-describedby="alert-dialog-modal-description"
            >
                <Typography id="alert-dialog-modal-title" level="h2" startDecorator={<WarningRounded />}>
                    Brisanje kompanije
                </Typography>
                <Divider />
                <Typography id="alert-dialog-modal-description" textColor="text.tertiary">
                    Da li ste sigurni da želite da obrišete kompaniju <b>{selectedCustomer?.name}</b>?
                </Typography>
                <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", pt: 2 }}>
                    <Button
                        variant="plain"
                        color="neutral"
                        onClick={() => onHandleClose()}
                    >
                        Otkaži
                    </Button>
                    <Button
                        variant="solid"
                        color="danger"
                        startDecorator={<Delete />}
                        onClick={handleDeleteCustomer}
                    >
                        Obriši kompaniju
                    </Button>
                </Box>
            </ModalDialog>
        </Modal>
    );
}

export default DeleteCustomerModal;